<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <div style="background: #fff; padding-left: 16px; height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex; margin-top: 10px">
              <a-input-search
                v-model="searchAreaValue"
                style="width: 100%; margin-right: 5px"
                allowClear
                :placeholder="$t('请输入区域名称')"
              />
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    @node-click="nodeClick"
                    ref="areaTree"
                  >
                  </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <a-tabs v-model="activeKey" @change="onTabChange">
          <a-tab-pane key="2" :tab="$t('当前轮检')">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('表编号')">
                      <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.searchMeterId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('检定结果')">
                      <j-dict-select-tag
                        v-model="queryParam.inspectionState"
                        :showSearch="false"
                        :placeholder="$t('请选择检定结果')"
                        dictCode="verification_results"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('到检日期')">
                      <a-range-picker
                        v-model="date"
                        format="YYYY-MM-DD"
                        :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                        @change="onDateRangeChange"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('操作员')">
                      <j-select-user-by-dep v-model="queryParam.inspectionBy" :multi="false"></j-select-user-by-dep>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('使用年限')">
                      <a-input-number
                        v-model="queryParam.usageYears"
                        :min="1"
                        :placeholder="$t('请输入使用年限')"
                        style="width: 100%"
                      ></a-input-number>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                        >{{ $t('重置') }}</a-button
                      >
                      <!-- <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button> -->
                      <a-button
                        type="primary"
                        icon="download"
                        @click="handleExportXls($t('当前轮检'))"
                        style="margin-left: 8px"
                        >{{ $t('导出') }}</a-button
                      >
                      <a-upload
                        name="file"
                        :showUploadList="false"
                        :multiple="false"
                        :headers="tokenHeader"
                        :action="importExcelUrl"
                        @change="handleImportExcel"
                      >
                        <a-button type="primary" icon="import" style="margin-left: 8px">{{ $t('导入') }}</a-button>
                      </a-upload>
                      <a-button type="link" icon="download" @click="downloadFormWork($t('轮检模板'))">{{ $t('下载模板') }}</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <div class="flex flex-center" style="margin-bottom: 15px">
              <div class="flex-item" style="height: 80px" v-for="item in totalList" :key="item.key">
                <div
                  class="flex-center"
                  style="height: 100%; background: #e6f7ff; border: 1px solid #91d5ff; flex-direction: column"
                >
                  <div class="flex-center">
                    <span class="" style="margin-left: 10px; font-size: 24px; font-weight: 500">{{ item.num }}</span>
                    <span class="unit" style="color: #999999">{{ item.unit }}</span>
                  </div>
                  <div class="flex-center" style="color: #999999">{{ item.title }}</div>
                </div>
              </div>
            </div>
            <div class="table-fixed">
              <a-table
                ref="table"
                size="middle"
                :scroll="{ x: true }"
                bordered
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :components="drag(columns)"
                @change="handleTableChange"
              >
                <span slot="userAccount" slot-scope="text, record">
                  <a-tag
                    style="font-size: 14px"
                    :color="
                      record.userAccountNum == null
                        ? ''
                        : record.userAccountNum <= 0
                        ? 'red'
                        : record.wtAlarmMoney < record.userAccountNum
                        ? 'green'
                        : 'orange'
                    "
                    >{{ record.userAccountNum }}</a-tag
                  >
                </span>
                <template slot="userStateSlot" slot-scope="text">
                  <a-button
                    :class="text == 1 ? 'normalbg-status' : text == 0 ? 'unactivebg-status' : ''"
                    v-if="text != null"
                  >
                    {{ text == 1 ? $t('已激活') : text == 0 ? $t('未激活') : '' }}
                  </a-button>
                </template>
                <template slot="mtState" slot-scope="text, record">
                  <a-tag style="font-size: 14px" v-if="text == 0">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                  <a-tag style="font-size: 14px" color="green" v-else-if="text == 1">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                  <a-tag style="font-size: 14px" color="blue" v-else-if="text == 2">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                  <a-tag style="font-size: 14px" color="red" v-else-if="text == 3">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                </template>
                <template slot="inspectionState" slot-scope="text, record">
                  <a-tag style="font-size: 14px" :color="text == 1 ? 'green' : 'red'" v-if="text != null">{{
                    filterDictTextByCache('verification_results', text)
                  }}</a-tag>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a @click="handleEdit(record)">{{ $t('更新检定') }}</a>
                  <a-divider type="vertical" />
                  <a-dropdown>
                    <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                      </a-menu-item>
                      <!-- <a-menu-item>
                        <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                          <a :disabled="record.id == null">删除</a>
                        </a-popconfirm>
                      </a-menu-item> -->
                    </a-menu>
                  </a-dropdown>
                </span>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="1" :tab="$t('轮检记录')">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('表编号')">
                      <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.searchMeterId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('用户编号')">
                      <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('检定结果')">
                      <j-dict-select-tag
                        v-model="queryParam.inspectionState"
                        :showSearch="false"
                        :placeholder="$t('请选择检定结果')"
                        dictCode="verification_results"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('操作员')">
                      <j-select-user-by-dep v-model="queryParam.inspectionBy" :multi="false"></j-select-user-by-dep>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px"
                        >{{ $t('重置') }}</a-button
                      >
                      <a-button
                        type="primary"
                        icon="download"
                        @click="handleExportXls($t('轮检记录'))"
                        style="margin-left: 8px"
                        >{{ $t('导出') }}</a-button
                      >
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- table区域-begin -->
            <div class="table-fixed">
              <a-table
                ref="table"
                size="middle"
                :scroll="{ x: true }"
                bordered
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :components="drag(columns)"
                @change="handleTableChange"
              >
                <span slot="userAccount" slot-scope="text, record">
                  <a-tag
                    style="font-size: 14px"
                    :color="
                      record.userAccountNum == null
                        ? ''
                        : record.userAccountNum <= 0
                        ? 'red'
                        : record.wtAlarmMoney < record.userAccountNum
                        ? 'green'
                        : 'orange'
                    "
                    >{{ record.userAccountNum }}</a-tag
                  >
                </span>
                <template slot="userStateSlot" slot-scope="text">
                  <a-button
                    :class="text == 1 ? 'normalbg-status' : text == 0 ? 'unactivebg-status' : ''"
                    v-if="text != null"
                  >
                    {{ text == 1 ? $t('已激活') : text == 0 ? $t('未激活') : '' }}
                  </a-button>
                </template>
                <template slot="mtState" slot-scope="text, record">
                  <a-tag style="font-size: 14px" v-if="text == 0">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                  <a-tag style="font-size: 14px" color="green" v-else-if="text == 1">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                  <a-tag style="font-size: 14px" color="blue" v-else-if="text == 2">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                  <a-tag style="font-size: 14px" color="red" v-else-if="text == 3">{{
                    filterDictTextByCache('meter_state', text)
                  }}</a-tag>
                </template>
                <template slot="inspectionState" slot-scope="text, record">
                  <a-tag style="font-size: 14px" :color="text == 1 ? 'green' : 'red'" v-if="text != null">{{
                    filterDictTextByCache('verification_results', text)
                  }}</a-tag>
                </template>
                <span slot="action" slot-scope="text, record">
                  <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                  <a-divider type="vertical" />
                  <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                    <a>{{ $t('删除') }}</a>
                  </a-popconfirm>
                  <!-- <a @click="handleEdit(record)">编辑</a>
                  <a-divider type="vertical" />
                  <a-dropdown>
                    <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="handleDetail(record)">{{ $t('详情') }}</a>
                      </a-menu-item>
                      <a-menu-item>
                        <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                          <a>{{ $t('删除') }}</a>
                        </a-popconfirm>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown> -->
                </span>
              </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
        <WheelInspectionModal ref="WheelInspectionModalRef" @ok="modalFormOk" />
      </a-card>
    </a-col>
  </a-row>
</template>
  <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { isUndefined, isEmptyObject } from '@/utils/validate'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { listSize, fileUrl } from '@/utils/util'
import { getAction, deleteAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import WheelInspectionModal from './WheelInspectionModal.vue'
import JDictSelectTag from '../../components/dict/JDictSelectTag.vue'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'

export default {
  name: 'WheelInspectionManagementList',
  mixins: [JeecgListMixin,AreaChoosetMixin, mixinDevice, TableDragResize],
  components: {
    JInput,
    JSelectUserByDep,
    WheelInspectionModal,
    JDictSelectTag,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      userTypeList: [], //表类型
      userCaliberList: [], // 表口径
      description: 'meterinfo管理页面',
      url: {
        exportXlsUrl: '/jeecg-charge/meterInspectionRecord/exportXls',
        importExcelUrl: 'jeecg-charge/meterInspectionRecord/importExcel',
        delete: '/jeecg-charge/meterInspectionRecord/delete',

        list: '/jeecg-charge/meterInspectionRecord/listRecord',
        exportXlsUrl1: '/jeecg-charge/meterInspectionRecord/exportRecordXls',
        importExcelUrl1: 'jeecg-charge/meterInspectionRecord/importExcel',
        delete1: '/jeecg-charge/meterInspectionRecord/delete',

        list2: '/jeecg-charge/meterInspectionRecord/list',
        exportXlsUrl2: '/jeecg-charge/meterInspectionRecord/exportXls',
        importExcelUrl2: 'jeecg-charge/meterInspectionRecord/importExcel',
        delete2: '/jeecg-charge/meterInspectionRecord/delete',
        userTypeList: '/jeecg-charge/meter/meterType/list', //表类型请求地址
        userCaliberList: '/jeecg-charge/meter/meterCaliber/list', //表口径请求地址
        getCount: '/jeecg-charge/meterInspectionRecord/getCount', //获取条目总数
      },
      dictOptions: {},
      dateType: 2,
      activeKey: '2',
      // 列定义（i18n：columns1/columns2 移入 computed，columns 由 activeKey 派生）
      // 统计项数值（totalList 改为 computed 后由此响应式承接）
      statData: {
        meterCount: '',
        inStoreroomCount: '',
        usageMeterCount: '',
        overInspectionCount: '',
        inspectionCount: '',
      },
    }
  },
  activated() {},
  created() {
    this.queryUserTypeList()
    this.queryUserCaliberList()
    console.log('执行creted生命周期')
    this.getTotalCount()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // i18n：统计项标题使用 computed 以响应语言切换
    totalList() {
      return [
        { key: 1, title: this.$t('表总数量'), num: this.statData.meterCount, unit: this.$t('只') },
        { key: 2, title: this.$t('在库表具数量'), num: this.statData.inStoreroomCount, unit: this.$t('只') },
        { key: 3, title: this.$t('安装数量'), num: this.statData.usageMeterCount, unit: this.$t('只') },
        { key: 4, title: this.$t('超期表数量'), num: this.statData.overInspectionCount, unit: this.$t('只') },
        { key: 5, title: this.$t('轮检数量'), num: this.statData.inspectionCount, unit: this.$t('只') },
      ]
    },
    // i18n：表头使用 computed 以响应语言切换
    columns1() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表口径'),
          dataIndex: 'caliber',
          align: 'center',
          customRender: t => 'DN' + t,
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('表类型'),
          dataIndex: 'mtName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表状态'),
          dataIndex: 'mtState',
          align: 'center',
          scopedSlots: { customRender: 'mtState' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户编号'),
          dataIndex: 'userId',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        // {
        //   title: '用户状态',
        //   dataIndex: 'userState',
        //   align: 'center',
        //   scopedSlots: { customRender: 'userStateSlot' },
        // },
        {
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户地址'),
          dataIndex: 'userAddr',
          align: 'center',
          width: 180,
          ellipsis: true,
        },
        {
          title: this.$t('检定结果'),
          dataIndex: 'inspectionState',
          align: 'center',
          scopedSlots: { customRender: 'inspectionState' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('检定日期'),
          dataIndex: 'inspectionTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'inspectionByName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('添加时间'),
          dataIndex: 'createTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns2() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表口径'),
          dataIndex: 'caliber',
          align: 'center',
          customRender: t => 'DN' + t,
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('表类型'),
          dataIndex: 'mtName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表状态'),
          dataIndex: 'mtState',
          align: 'center',
          scopedSlots: { customRender: 'mtState' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户编号'),
          dataIndex: 'userId',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户状态'),
          dataIndex: 'userState',
          align: 'center',
          scopedSlots: { customRender: 'userStateSlot' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('当前余额(元)'),
          align: 'center',
          dataIndex: 'userAccountNum',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'userAccount' },
        },
        {
          title: this.$t('出厂日期'),
          align: 'center',
          dataIndex: 'productionTime',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户地址'),
          dataIndex: 'userAddr',
          align: 'center',
          width: 180,
          ellipsis: true,
        },
        {
          title: this.$t('检定结果'),
          dataIndex: 'inspectionState',
          align: 'center',
          scopedSlots: { customRender: 'inspectionState' },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('检定日期'),
          dataIndex: 'inspectionTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('到检日期'),
          dataIndex: 'nextInspectionTime',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作员'),
          dataIndex: 'inspectionByName',
          align: 'center',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns() {
      // 当前轮检（tab 2）使用 columns2，轮检记录（tab 1）使用 columns1
      return this.activeKey == '1' ? this.columns1 : this.columns2
    },
  },
  methods: {
    getTotalCount() {
      getAction(this.url.getCount).then(res => {
        if (res.success) {
          let result = res.result
          for (const key in result) {
            if (key == 'meterCount') this.statData.meterCount = result[key]
            if (key == 'inStoreroomCount') this.statData.inStoreroomCount = result[key]
            if (key == 'usageMeterCount') this.statData.usageMeterCount = result[key]
            if (key == 'overInspectionCount') this.statData.overInspectionCount = result[key]
            if (key == 'inspectionCount') this.statData.inspectionCount = result[key]
          }
        }
      })
    },
    loadData(arg) {
      let url = ''
      if (this.activeKey == 1) {
        url = this.url.list
      } else if (this.activeKey == 2) {
        url = this.url.list2
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      getAction(url, params).then(res => {
        if (res.success && res.result) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    onTabChange(e) {
      this.activeKey = e
      switch (this.activeKey) {
        case '1':
          this.url.exportXlsUrl = this.url.exportXlsUrl1
          this.url.importExcelUrl = this.url.importExcelUrl1
          this.url.delete = this.url.delete1
          break
        case '2':
          this.url.exportXlsUrl = this.url.exportXlsUrl2
          this.url.importExcelUrl = this.url.importExcelUrl2
          this.url.delete = this.url.delete2
          break
      }
      this.loadData(1)
    },
    initDictConfig() {},
    queryUserTypeList() {
      //表类型请求
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      getAction(this.url.userTypeList, params).then(res => {
        if (res.success) {
          this.userTypeList = res.result.records
        }
      })
    },
    queryUserCaliberList() {
      //表口径请求
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      params.column = 'mtCaliber'
      params.order = 'asc'
      getAction(this.url.userCaliberList, params).then(res => {
        if (res.success) {
          this.userCaliberList = res.result.records
        }
      })
    },
    handleAdd() {
      switch (this.activeKey) {
        case '1':
          break
        case '2':
          this.$refs.WheelInspectionModalRef.add()
          this.$refs.WheelInspectionModalRef.title = this.$t('新增')
          this.$refs.WheelInspectionModalRef.disableSubmit = false
          break
      }
    },
    handleEdit(record) {
      switch (this.activeKey) {
        case '1':
          break
        case '2':
          this.$refs.WheelInspectionModalRef.edit({meterId: record.meterId})
          this.$refs.WheelInspectionModalRef.title = this.$t('更新检定')
          this.$refs.WheelInspectionModalRef.disableSubmit = false
          break
      }
    },
    handleDetail(record) {
      switch (this.activeKey) {
        case '1':
          this.$refs.WheelInspectionModalRef.edit(record)
          this.$refs.WheelInspectionModalRef.title = this.$t('详情')
          this.$refs.WheelInspectionModalRef.disableSubmit = true
          break
        case '2':
          this.$refs.WheelInspectionModalRef.edit(record)
          this.$refs.WheelInspectionModalRef.title = this.$t('详情')
          this.$refs.WheelInspectionModalRef.disableSubmit = true
          break
      }
    },
    downloadFormWork(fileName) {
      console.log('下载批量报装模板')
      let deviceFileUrl = '/file/wheel_inspection.xls'
      let url = `${fileUrl}${deviceFileUrl}`
      if (!fileName || typeof fileName != 'string') {
        fileName = this.$t('导出文件')
      }
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      console.log(fileName)
      link.setAttribute('download', fileName + '.xls')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) //下载完成移除元素
      window.URL.revokeObjectURL(link.href) //释放掉blob对象
    },
    nodeClick(record, node, data) {
      console.log(record)
      console.log(node)
      console.log(data)
      // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
      if (node.checked) {
        this.currentNodeKey = record.id
        this.$refs.areaTree.setCheckedKeys([record.id])
        this.currSelected = Object.assign({}, record)
        // 有的接口是areaId有的接口是userAreaId，兼容两个都写
        this.queryParam.areaId = this.currSelected.id
      } else {
        this.currentNodeKey = null
        this.currSelected = {}
        this.$refs.areaTree.setCheckedKeys([])
        // 有的接口是areaId有的接口是userAreaId，兼容两个都写
        delete this.queryParam.areaId
      }
      this.loadData(1);
    },
    resetAareaData() {
      console.log('areaChoose')
      this.hiding = true
      this.checkedKeys = []
      this.currSelected = {}
      this.selectedKeys = []
      delete this.queryParam.areaId
      if (this.rootOpened) {
        this.setThisExpandedKeys(this.areaTree)
      }

      // 20220228修改的
      this.currentNodeKey = null
      if (this.$refs.areaTree) {
        this.$refs.areaTree.setCheckedKeys([])
      }
      this.loadData(1);
    },
  },
}
</script>
  <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>